import { Box, Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import moment from "moment-timezone";
import { useEffect, useState } from "react";

export default function AppbarCustom({ logo, icon, tempBar, step, children }) {
  const today = new Date();
  const hourago = new Date(today.getTime());
  const timestr =
    moment(hourago).tz("Asia/Bangkok").format("DD/MM/") +
    (parseInt(moment(hourago).tz("Asia/Bangkok").format("YY")) + 43);

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        style={{
          backgroundColor: "#242424",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Toolbar variant="string" sx={{ height: "clamp(33px, 8vh, 100px)" }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <span
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "clamp(30px, 3vw, 48px)",
                  position: "relative",
                  left: "-1vw",
                  marginLeft: "-18px",
                  background: "#2e9281",
                  padding: "0 5px",
                }}
              >
                {logo && <img src={logo} alt="" width="25" height="25" />}
                STEP {step}
              </span>
              <span
                style={{
                  color: "#2e9281",
                  fontWeight: "bold",
                  fontSize: "clamp(23px, 3vw, 42px)",
                  position: "relative",
                  left: "-1vw",
                  alignItems: "center",
                  padding: "0 5px",
                }}
              >
                {children}
              </span>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: "flex", float: "right", gap: "10px" }}>
                <Typography
                  style={{
                    color: "#ffffff",
                    fontWeight: "bold",
                    fontSize: "clamp(30px, 3vw, 48px)",
                  }}
                >
                  {timestr}
                </Typography>
                <Typography
                  style={{
                    color: "#ffffff",
                    fontWeight: "bold",
                    fontSize: "clamp(30px, 3vw, 48px)",
                  }}
                >
                  {time.toLocaleTimeString("en-GB")}
                </Typography>
                {icon && (
                  <Typography style={{ display: "flex", alignItems: "center" }}>
                    {icon}
                  </Typography>
                )}
                {tempBar && (
                  <Typography
                    sx={{
                      color: "#ffffff",
                      fontWeight: "bold",
                      fontSize: "clamp(25px, 3vw, 44px)",
                    }}
                  >
                    {tempBar}
                    {tempBar && (
                      <span style={{ fontSize: "clamp(20px, 2vw, 40px)" }}>
                        °C
                      </span>
                    )}
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
